import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
	ModalTransition,
} from '@atlaskit/modal-dialog';

import { messages } from './messages';
import { type DeleteModalProps } from './types';

export const DeleteModal: React.FC<DeleteModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
	name,
	returnFocusRef,
}) => {
	const { formatMessage } = useIntl();

	return (
		<ModalTransition>
			{isOpen && (
				<Modal width="small" onClose={onClose} shouldReturnFocus={returnFocusRef}>
					<ModalHeader>
						<ModalTitle appearance="warning">{formatMessage(messages.title)}</ModalTitle>
					</ModalHeader>
					<ModalBody>{formatMessage(messages.description, { name: name || false })}</ModalBody>
					<ModalFooter>
						<Button appearance="subtle" onClick={onClose}>
							{formatMessage(messages.cancelButton)}
						</Button>
						<Button appearance="warning" onClick={onConfirm}>
							{formatMessage(messages.deleteButton)}
						</Button>
					</ModalFooter>
				</Modal>
			)}
		</ModalTransition>
	);
};
